import axios from "axios";
import { APIGEE_TOKEN_URL } from "../config/apigeeConfig";
import { isAuthenticated, redirectToLogin } from "../utils/auth";
import { noteAxiosApigeeResponse } from "../utils/apigeeSnapshotStatus";

const DEFAULT_API_BASE_URL = "https://forgeaigateway.probestack.io/apigee-wrapper";
const env = import.meta.env || {};
const API_BASE_URL = env.VITE_AI_GATEWAY_API_BASE_URL || env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL;
// const ADMIN_API_KEY = env.VITE_AI_GATEWAY_ADMIN_API_KEY || env.VITE_ADMIN_API_KEY;

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // decision #51: saved data needs the session cookie.
});

api.interceptors.response.use(noteAxiosApigeeResponse);

// Any user-triggered API call re-checks the main-app session cookie, so a
// logout elsewhere is caught the moment the user does something here
// instead of only on the next page reload.
api.interceptors.request.use((config) => {
  if (!isAuthenticated()) {
    redirectToLogin();
    return Promise.reject(new axios.Cancel("Session expired, redirecting to login"));
  }

  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Auto login (get token)
export const initAuth = async () => {
  try {
    const res = await axios.get(APIGEE_TOKEN_URL);

    // The response field is access_token (reading accessToken stored "undefined").
    localStorage.setItem("token", res.data.access_token);
    return res.data.access_token;
  } catch (err) {
    console.error("Auth failed", err);
  }
};

export default api;
